import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import styles from "./AppLayout.module.css";
import Header from "../Header/Header";
import NavBar from "../NavBar/NavBar";
import { useAuthStore } from "src/features/auth";
import { UpdateBanner } from "../../../features/app-update";
import { PushBanner, PushRegistrar } from "../../../features/push-notifications";
import { useDockedPanelWidth } from "../../../shared/lib/dockedPanel";
import clsx from "clsx";
import { hasOnlyRole } from "@myapp/contract";

const AppLayout: FC = () => {
  const { user } = useAuthStore()
  const isWorker = hasOnlyRole(user?.roles ?? [], 'WORKER')
  /**
   * A docked upsert panel (the disposition board's forms) is `position: fixed` over the right edge.
   * Reserving its width here is what lets the page shrink beside it instead of being covered —
   * the stylesheet reads the variable, and the media query below 1100px zeroes it again, where the
   * panel takes the whole screen anyway.
   */
  const dockedPanelWidth = useDockedPanelWidth()
  return (
    <div className={styles.page}>
      <Header />
      <div
        className={styles.pageRow}
        style={{ "--docked-panel": `${dockedPanelWidth ?? 0}px` } as React.CSSProperties}
        data-docked-panel={dockedPanelWidth != null ? "" : undefined}
      >
        <NavBar />
        <div className={clsx(styles.main, 'AppLayout', isWorker && styles.workerMain)}>
          {/* Headless: re-registers this device for push on every app open, never prompts. */}
          <PushRegistrar />
          {/* Update notice first: it only shows once a newer build is deployed. */}
          <UpdateBanner />
          {/* The one standing banner: notifications. Installing is optional and deliberately lives
              only behind "App installieren" in the burger menu. */}
          {user && <PushBanner userId={user.id} />}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AppLayout;